import React from "react"

import {DealCategory, DealsTag} from "@irati/types"

import NoExist from "@irati/ui/src/Layout/NoExist"

export const ERROR_CATEGORY: DealCategory = {
  name: "Error",
  tags: [],
  active: true,
  image: "",
  onMenu: false,
  url: "",
  uuid: "",
  type: "error",
  isGeolocationRelated: false
}

export const ALL_CATEGORY: DealCategory = {name: "perks.categories.allLabel", url: "", onMenu: true, tags: []}

const isBadCategory = (category?: DealCategory) => {
  return !category || category === ERROR_CATEGORY
}

const isBadTag = (category?: DealCategory, tags?: DealsTag[]) => {
  return category && category !== ALL_CATEGORY && tags?.length === 0
}

interface Props {
  category?: DealCategory
  tags?: DealsTag[]
}

const BadCategoryOrTag: React.FC<Props> = (props) => {
  const {category, tags, children} = props
  if (isBadCategory(category) || isBadTag(category, tags)) {
    return <NoExist />
  }

  return <>{children}</>
}

export default BadCategoryOrTag
